import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { theme } from 'utils/style'

import Paragraph from 'components/Paragraph/Paragraph'

const StyledParagraph = styled(Paragraph)`
  a {
    text-decoration: none;
    color: ${theme('colors.primary')};
    cursor: pointer;
    transition: color 0.1s ease;

    &:hover {
      text-decoration: none;
      color: ${theme('colors.hover.secondary')};
    }
  }
`

const RichTextContent = ({ content, ...props }) => (
  <StyledParagraph dangerouslySetInnerHTML={{ __html: content }} {...props} />
)

RichTextContent.propTypes = {
  content: PropTypes.string.isRequired,
}

export default RichTextContent
